import { createContext, type ReactNode, useContext } from 'react'

/** Set where something around the tab already shows its title, e.g. a dialog's header. */
export const FillTabTitleShownContext = createContext(false)

interface FillTabHeaderProps {
  title: string
  description?: ReactNode
  /** Shown on the right, e.g. Add a claim. */
  action?: ReactNode
}

/** A tab's title above its cards. */
export function FillTabHeader({ title, description, action }: FillTabHeaderProps) {
  const titleShown = useContext(FillTabTitleShownContext)
  if (titleShown && !description && !action) return null

  return (
    <div className="flex flex-wrap items-start justify-between gap-3">
      <div className="flex flex-col gap-1">
        {!titleShown && <h2 className="text-ink text-lg font-semibold">{title}</h2>}
        {description && <p className="text-ink-500 text-sm">{description}</p>}
      </div>
      {action}
    </div>
  )
}
